<rt-typeahead
  [suggestions]="$any(suggestions)"
  [minLength]="0"
  [inputDebounce]="0"
  (changed)="onChange($event)"
>
  <rt-group variant="stacked horizontal">
    <rt-input rtTypeaheadInput [formControl]="input.control" variant="rounded"> </rt-input>
  </rt-group>
</rt-typeahead>
